module.exports = __webpack_public_path__ + "img/delphoi_top.594c80c5.png";